const config={
    BACKEND_URL: "https://garage-backend.intern.embiso.com/"
}

export default config;